export const selectors = {
  initialSize: (state) => state.config.initialSize,
}
